import React from 'react';
import loading_icon from '../../images/home/loading.gif';
import './defaultLoading.scss';

const DefaultLoading = () => (
    <img src={loading_icon} className="initial_loading" alt="Loading..." />
);

export default DefaultLoading;
